import {棚卸差数在庫場所結果型, 棚卸差数棚卸年月日型, 棚卸差数検索依頼型, 棚卸差数結果型} from '@/type/inquire/item';
import {InventoryDiffApi} from '@/infrastructure/api/inquire/inventoryDiffApi';
import Auth from '@/infrastructure/api/helper/Auth';
import download from '@/infrastructure/api/download';

export class GoryoukakuInventoryDiffApi implements InventoryDiffApi {

  async 棚卸差数在庫場所一覧を取得する(): Promise<棚卸差数在庫場所結果型> {
    const auth = new Auth();
    const response = await auth.get('/api/custom/goryoukaku/inquire/inventory_diff/inventory_location');
    const 在庫場所一覧 = response.data;
    return 在庫場所一覧;
  }

  async 棚卸差数棚卸年月日一覧を取得する(部署コード: string): Promise<棚卸差数棚卸年月日型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/custom/goryoukaku/inquire/inventory_diff/inventory_date/' + 部署コード);
    const 棚卸年月日一覧 = response.data;
    return 棚卸年月日一覧;
  }

  async 棚卸差数一覧を取得する(棚卸差数検索依頼: 棚卸差数検索依頼型): Promise<棚卸差数結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/goryoukaku/inquire/inventory_diff', 棚卸差数検索依頼);
    const 棚卸差数一覧 = response.data;
    return 棚卸差数一覧;
  }

  async 棚卸差数一覧表を出力する(filename: string, 検索内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post(
        '/api/custom/goryoukaku/inquire/inventory_diff/download/excel',
        検索内容,
        {responseType: 'blob'});
    const file = response.data;
    // this.excelout(file, filename);
    download.excelout(file, filename);
  }
}
